// extracted by mini-css-extract-plugin
module.exports = {"droppedBox":"Dropdowner_droppedBox","dropdownerContainer":"Dropdowner_dropdownerContainer"};